export default __webpack_public_path__ + "static/media/q18_01.1c4215be.png";